import React from 'react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
};
export function SectionCTA({
  label,
  note = 'One-time payment of $27 · Instant access · 7-day guarantee',
  tone = 'light'
}: SectionCTAProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-244" data-mp="1qbenddlcynk4">
      <CTAButton label={label} data-id="element-245" data-mp="1qa3beqhre9hx" />
      <p className={`mt-3 text-center text-sm ${tone === 'dark' ? 'text-white/65' : 'text-muted'}`} data-id="element-246" data-mp="1bna3456nq3z8">{note}</p>
    </div>;
}